import { motion } from "framer-motion";
import { METRICS } from "@/data/site";

export default function MetricsBand({ dark = true }) {
  return (
    <section
      data-testid="metrics-band"
      className={`${dark ? "bg-[#0A1F44] text-white" : "bg-slate-50 text-[#0A1F44]"} relative overflow-hidden`}
    >
      <div className={`absolute inset-0 ${dark ? "opacity-[0.06]" : "opacity-[0.5]"} grid-pattern pointer-events-none`} />
      <div className="sozos-container relative section-pad">
        <div className="max-w-3xl">
          <p className={`eyebrow ${dark ? "text-blue-300" : ""}`}>Impact, measured</p>
          <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-3 ${dark ? "text-white" : "text-[#0A1F44]"}`}>
            Outcomes our clients build their boards around.
          </h2>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {METRICS.map((m, i) => (
            <motion.div
              key={m.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`metric-${i}`}
            >
              <div className={`font-display text-6xl md:text-7xl font-bold ${dark ? "text-white" : "text-[#0A1F44]"} tracking-tight`}>
                {m.value}
              </div>
              <div className={`mt-3 text-sm md:text-base font-semibold uppercase tracking-widest ${dark ? "text-blue-300" : "text-[#1E40AF]"}`}>
                {m.label}
              </div>
              <p className={`mt-2 text-sm ${dark ? "text-slate-300" : "text-slate-600"} leading-relaxed max-w-xs`}>
                {m.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
